module.exports = __webpack_public_path__ + "img/trade-10.090ce6da.svg";